import React from 'react';

export const ParagraphElement = ({ children, attributes = {}, className = '', style = {} }) => {

  return (
    <p
      {...attributes}
      className={className}
      style={style}
    >
      {children}
    </p>
  );
};
